import { render, staticRenderFns } from "./RecentInquiry.vue?vue&type=template&id=dbffba5e"
import script from "./RecentInquiry.vue?vue&type=script&lang=js"
export * from "./RecentInquiry.vue?vue&type=script&lang=js"
import style0 from "./RecentInquiry.vue?vue&type=style&index=0&id=dbffba5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports